import { Link } from 'react-router-dom';
import type { MediaItem } from '@/mocks/media';

interface MovieCardProps {
  item: MediaItem;
  className?: string;
}

export default function MovieCard({ item, className = '' }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className={`group flex flex-col cursor-pointer ${className}`}
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-secondary-100">
        <img
          src={item.poster}
          alt={`${item.title}海报`}
          title={`${item.title} - 看片影视`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <span className="absolute top-2 right-2 flex items-center gap-0.5 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-bold">
          <i className="ri-star-fill text-[10px]"></i>
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute inset-x-0 bottom-0 p-3 text-background-50 text-xs opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300">
          查看详情
          <i className="ri-arrow-right-line ml-1"></i>
        </span>
      </div>
      <h3 className="mt-2.5 text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
        {item.title}
      </h3>
      <div className="mt-1 flex items-center gap-1.5 text-xs text-foreground-500">
        <span>{item.year}</span>
        <span className="w-0.5 h-0.5 rounded-full bg-foreground-300"></span>
        <span className="line-clamp-1">{item.genres.join(' · ')}</span>
      </div>
    </Link>
  );
}